import { err, ok } from '@xlearn/common';
import { SchemaError, ErrorCode } from '../schema-engine';
import { CompletionStatus, statusToString, parseStatus } from '../../api';

export function getCompletionStatus(status: CompletionStatus) {
  return ok(statusToString(status));
}

export function setCompletionStatus(currentStatus: CompletionStatus, value: string) {
  const parsed = parseStatus(value);
  if (!parsed.success) {
    return err(new SchemaError(ErrorCode.incorrectDataType, value));
  }

  return ok(parsed.value);
}
